import dhtmlXGridCellObject from './dhtmlXGridCellObject';

var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var eXcell = (function (_super) {
    __extends(eXcell, _super);
    function eXcell() {
        _super.call(this);
        this.obj = null;
        this.val = null;
    }
    eXcell.prototype.changeState = function (a) {
        return false;
    };
    eXcell.prototype.isDisabled = function () { };
    eXcell.prototype.edit = function () {
        this.val = this.getValue();
    };
    eXcell.prototype.detach = function () {
        return false;
    };
    eXcell.prototype.getPosition = function (g) {
        var a = g;
        var e = 0;
        var c = 0;
        while (a.tagName != "BODY") {
            e += a.offsetLeft;
            c += a.offsetTop;
            a = a.offsetParent;
        }
        return new Array(e, c);
    };
    return eXcell;
})(dhtmlXGridCellObject);

export  {eXcell,__extends};



// WEBPACK FOOTER //
// ./goingsrc/dx/dxSource/components/gridXCell/eXcell.js